import { render, staticRenderFns } from "./BrazilErrorLabel.vue?vue&type=template&id=fa1335d2&scoped=true&lang=html&"
import script from "./BrazilErrorLabel.vue?vue&type=script&lang=js&"
export * from "./BrazilErrorLabel.vue?vue&type=script&lang=js&"
import style0 from "./BrazilErrorLabel.vue?vue&type=style&index=0&id=fa1335d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1335d2",
  null
  
)

export default component.exports